
class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        let serachTypeText

        if(this.props.page === "auction"){
            if(LANG['Oksjonite']){
                serachTypeText = LANG['Oksjonite']
            } else {
                serachTypeText = 'Oksjonite'
            }
        } else if(this.props.page === "post"){
            if(LANG['Kuulutuste']){
                serachTypeText = LANG['Kuulutuste']
            } else {
                serachTypeText = 'Kuulutuste'
            }
        }
        this.state = {
            serachTypeText: serachTypeText,
            serachPlaceholder: LANG['Märksõna'] || 'Märksõna'

        };
    }


    render(county= this.props.filterCounty, sort= this.props.sort) {
        return (
            <React.Fragment>
                <section className={'search-bar cell large-12 medium-12 small-12 grid-x grid-padding-x align-center'}>
                    <section className="large-8 medium-12 small-12 cell grid-x  grid-padding-x align-center">
                        <section className="small-3 medium-2 large-auto cell grid-x align-right size-10">
                            <label  className="text-right middle">{this.state.serachTypeText} {LANG['otsing'] || 'otsing'}</label>
                        </section>
                        <section className="small-9 medium-10 large-auto cell grid-x ">
                            <input type="text" onChange={this.props.handleInput} placeholder={this.state.serachPlaceholder} name={"keyword"} value={this.props.keyword}/>
                        </section>

                        <section className="small-3 medium-2 large-auto cell grid-x align-right size-6">
                            <label  className="text-right middle">{LANG['Asukoht'] || 'Asukoht'}</label>
                        </section>
                        <section className="small-9 medium-10 large-auto cell grid-x size-10">
                            <select onChange={this.props.handleInput} name={"county"}>
                                {county.length <= 1?
                                    <React.Fragment>
                                        <option value={' '}  selected={county.length === 0 ? true : false}>{LANG['Kõik'] || 'Kõik'}</option>
                                        {county.length === 0 ? '':<option value={county} selected={county.length === 1 ? true : false}>{county}</option>}
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <option value={' '} selected={true}>{LANG['Kõik'] || 'Kõik'}</option>
                                        {county.map((county,index)=>{
                                        return (
                                        <option key={index}>{county}</option>
                                        )
                                    })}
                                    </React.Fragment>
                                   }
                            </select>
                        </section>


                        {this.props.page === "auction" ?
                            <section className="small-12 medium-12 large-auto cell grid-x size-10 clear-filter">
                                <button className="button"
                                        onClick={this.props.handleInput} name={'clear'}>{LANG['Puhasta filter'] || 'Puhasta filter'}
                                </button>
                            </section>
                            :
                            <React.Fragment>
                                <section className="small-3 medium-2 large-auto cell grid-x align-right size-10">
                                    <label  className="text-right middle">{LANG['Hinnavahemik'] || 'Hinna' + '\u00AD' + 'vahemik'}</label>
                                </section>
                                <section className={'small-9 medium-10 large-auto cell grid-x align-right size-10'}>
                                    <section className="auto cell grid-x size-6">
                                        <input onChange={this.props.handleInput} placeholder={'900'} name={"minprice"} type={'number'} value={this.props.minprice}/>
                                    </section>
                                    <span>-</span>
                                    <section className="auto cell grid-x size-6">
                                        <input onChange={this.props.handleInput} placeholder={'8 800'} name={"maxprice"} type={'number'} value={this.props.maxprice}/>
                                    </section>
                                </section>
                                <section className="small-12 medium-12 large-auto cell grid-x size-10 clear-filter">
                                    <button className="button "
                                            onClick={this.props.handleInput} name={'clear'}>{LANG['Puhasta filter'] || 'Puhasta filter'}
                                    </button>
                                </section>
                            </React.Fragment>
                        }



                    </section>
                    <section className="small-3 medium-2 large-auto cell grid-x align-right">
                        <label  className="text-right middle">{LANG['Järjesta'] || 'Järjesta'}</label>
                    </section>
                    <section className="small-9 medium-10 large-auto cell grid-x size-10">
                        <select onChange={this.props.handleInput} name={"sort"}>
                            <option selected={sort==="new" ? true : false} value={"new"}>{LANG['Uuemad enne'] || 'Uuemad enne'}</option>
                            <option selected={sort==="old" ? true : false} value={"old"}>{LANG['Vanemad enne'] || 'Vanemad enne'}</option>
                            {this.props.page === "post" ?
                                <React.Fragment>
                                    <option selected={sort==="cheap" ? true : false} value={"cheap"}>{LANG['Odavamad enne'] || 'Odavamad enne'}</option>
                                    <option selected={sort==="expensive" ? true : false} value={"expensive"}>{LANG['Kallimad enne'] || 'Kallimad enne'}</option>
                                </React.Fragment>  : ''}
                            {console.log(sort)}
                        </select>
                    </section>

                </section>
            </React.Fragment>
        )
    }
}

export default SearchBar;

